var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdviserPortal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6059 6.33333V4.91667C17.6059 4.13426 17.0985 3.5 16.4726 3.5H2.87259C2.24667 3.5 1.73926 4.13426 1.73926 4.91667V19.0833C1.73926 19.8657 2.24667 20.5 2.87259 20.5H16.4726C17.0985 20.5 17.6059 19.8657 17.6059 19.0833V11.4333",
    stroke: "#F4F4F9",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1502 10.4722C14.9582 10.5814 14.8918 10.8253 15.0018 11.0169C15.1119 11.2084 15.3567 11.2751 15.5487 11.1659L15.3495 10.819L15.1502 10.4722ZM21.5407 7.75671C21.7327 7.64746 21.7992 7.40361 21.6891 7.21205C21.5791 7.02049 21.3342 6.95377 21.1422 7.06301L21.3415 7.40986L21.5407 7.75671ZM15.3495 10.819L15.5487 11.1659L21.5407 7.75671L21.3415 7.40986L21.1422 7.06301L15.1502 10.4722L15.3495 10.819Z",
    fill: "#F4F4F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5692 6.7431L21.342 7.41019L20.6193 10.169",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57253 6.9C4.88549 6.9 5.13919 6.64629 5.13919 6.33333C5.13919 6.02037 4.88549 5.76666 4.57253 5.76666C4.25956 5.76666 4.00586 6.02037 4.00586 6.33333C4.00586 6.64629 4.25956 6.9 4.57253 6.9Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83925 6.9C7.15221 6.9 7.40592 6.64629 7.40592 6.33333C7.40592 6.02037 7.15221 5.76666 6.83925 5.76666C6.52629 5.76666 6.27258 6.02037 6.27258 6.33333C6.27258 6.64629 6.52629 6.9 6.83925 6.9Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10585 6.9C9.41881 6.9 9.67252 6.64629 9.67252 6.33333C9.67252 6.02037 9.41881 5.76666 9.10585 5.76666C8.79289 5.76666 8.53918 6.02037 8.53918 6.33333C8.53918 6.64629 8.79289 6.9 9.10585 6.9Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73926 9.16667H13.0726",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61577 14.8333C10.5547 14.8333 11.3158 14.0722 11.3158 13.1333C11.3158 12.1945 10.5547 11.4333 9.61577 11.4333C8.67689 11.4333 7.91577 12.1945 7.91577 13.1333C7.91577 14.0722 8.67689 14.8333 9.61577 14.8333Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67259 14.8333C12.4473 14.8333 13.1635 16.6578 13.3484 17.5997C13.4076 17.901 13.1083 18.1483 12.7327 18.1483H6.61244C6.23686 18.1483 5.9376 17.901 5.99675 17.5997C6.18163 16.6578 6.89789 14.8333 9.67259 14.8333Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdviserPortal);
export default __webpack_public_path__ + "static/media/AdviserPortal.f2c7c21a44512fd03272ea9478dd076f.svg";
export { ForwardRef as ReactComponent };